import debug from 'debug';
import CloudApi from 'Minetilbud/Shared/Components/CloudApi/Search';
import Facets from '../utils/facets';

const log = debug('InspirationProductsByCategory:Data:ProductsByCategory');

class ProductsByCategory {
	/**
	 * @returns {Promise} products
	 */
	async get({ categories, excludeBorderShops, numberOfResults }) {
		try {
			const facets = Facets.get({ categories, excludeBorderShops, numberOfResults });
			log('get() - facets', facets);

			const cloadapi = new CloudApi();
			const response = await cloadapi.productsByCategories(facets);

			if (response.status !== 200) {
				return [];
			};

			const dataset = await response.json();
			const products = dataset.adverts;
			return products;
		} catch(error) {
			log('get() - error', error);
		}
	}
}

export default ProductsByCategory;
